import React, { useCallback } from 'react';
import styled from '@emotion/styled';
import { rgba } from 'polished';
import { useDispatch } from 'react-redux';

import { useStateBus } from '~/state/bridge';

import { getAdName, getCampaignName } from '~/state/Campaign/selectors';
import { getSelectedForm } from '~/state/LeadAds/selectors';

import Label from '~/theseus/components/Form/Label';
import Input from '~/theseus/components/Form/Input';

import CampaignClient from '~/state/Campaign/client';

import SectionToggle from '../SectionToggle';

const Field = styled(Label)`
  display: flex;
  width: 100%;
  margin-bottom: 20px;
  
  .label {
    margin-right: 10px;
    font-weight: 500;
  }

  input {
    flex-grow: 2;
  }
`;

const LeadAdName = styled.div`
  width: 100%;
  margin: 20px auto;
  padding-bottom: 10px;
  border-radius: 4px;
  border: 1px solid ${rgba('#000', 0.1)};

  &:before {
    content: 'The campaign name will be automatically set to assign a search, source and agent';
    display: block;
    padding: 8px;
    margin-bottom: 10px;
    font-size: 12px;
    font-weight: 500;
    background: ${rgba('#000', 0.05)};
    border-top-left-raidus: 4px;
    border-top-right-raidus: 4px;
  }
`;

// TODO: Extract this to CampaignForm component
export default function CampaignName() {
  const campaignName = useStateBus(getCampaignName);
  const adName = useStateBus(getAdName);
  const selectedLeadAd = useStateBus(getSelectedForm);
  const dispatch = useDispatch();

  const updateName = useCallback(e => {
    dispatch({ type: 'changeAdName', payload: e.target.value });
  }, [dispatch]);

  return (
    <div>
      <Field htmlFor="ad-name">
        <span className="label">
          Campaign Name
        </span>
        <Input
          id="ad-name"
          type="text"
          maxLength="250"
          value={campaignName}
          disabled={!!selectedLeadAd}
          onChange={updateName}
        />
      </Field>
      <SectionToggle enabledOn={!!selectedLeadAd}>
        <LeadAdName>
          <Field css={{ width: '50%', marginLeft: 20 }}>
            <span className="label">Ad Name</span>
            <Input type="text" value={adName} onChange={updateName} />
          </Field>
        </LeadAdName>
      </SectionToggle>
    </div>
  );
}
